import React from "react";
import "../../styles/CustomerTab.css";

const CustomerTab = ({ payment }) => {

    const customer = payment?.customerSnapshot;

    if (!customer) return null;

    return (
        <div className="customer-card">

            <h3>Customer Information</h3>

            <div className="customer-grid">

                <div>
                    <label>Name</label>
                    <p>{customer.name}</p>
                </div>

                <div>
                    <label>Phone</label>
                    <p>{customer.phone}</p>
                </div>

                <div>
                    <label>Email</label>
                    <p>{customer.email}</p>
                </div>

                <div>
                    <label>Customer ID</label>
                    <p>{customer.customerId || "-"}</p>
                </div>

                <div className="full-width">
                    <label>Address</label>
                    <p>{customer.address || "-"}</p>
                </div>

            </div>

        </div>
    );

};

export default CustomerTab;